import React, { useMemo } from 'react';
import { getExperiences } from '../data/experiences.index';
import { useLanguage } from '../context/LanguageContext';

function Experience() {
  const { lang, t } = useLanguage();
  const experiences = useMemo(() => getExperiences(lang), [lang]);

  return (
    <div className="space-y-12 animate-fade-in text-white">
      <div className="space-y-4">
        <h1 className="text-3xl md:text-5xl font-extrabold text-white tracking-tight">
          {t('sections.experienceTitle')}
        </h1>
        <p className="text-white/70 text-base md:text-lg max-w-2xl leading-relaxed">
          {lang === 'ar'
            ? 'سجل مهني يجمع بين القيادة التنفيذية، وهندسة الأنظمة الحيوية، والامتثال التنظيمي العالمي.'
            : 'A track record combining executive technology leadership, mission-critical systems engineering, and global regulatory compliance.'}
        </p>
        <div className="h-1 w-20 bg-primary-500 rounded-full"></div>
      </div>

      <div className="relative border-l-2 rtl:border-r-2 rtl:border-l-0 border-white/10 ml-3 rtl:mr-3 rtl:ml-0 pl-6 sm:pl-8 rtl:pr-6 rtl:sm:pr-8 rtl:pl-0 space-y-10">
        {experiences.map((exp, index) => (
          <article 
            key={index} 
            className="group relative p-7 sm:p-9 rounded-3xl bg-white/[0.03] border border-white/10 hover:border-primary-500/40 hover:bg-white/[0.05] transition-all duration-300 shadow-xl space-y-5"
          >
            {/* Timeline node dot */}
            <div className="absolute -left-[31px] sm:-left-[39px] rtl:-right-[31px] rtl:sm:-right-[39px] rtl:left-auto top-10 w-4 h-4 rounded-full bg-dark-950 border-2 border-primary-400 group-hover:scale-125 group-hover:bg-primary-500 transition-all duration-300"></div>

            <div className="flex flex-col md:flex-row md:items-start justify-between gap-4 border-b border-white/10 pb-5">
              <div className="space-y-1.5">
                <h2 className="text-xl sm:text-2xl font-bold text-white group-hover:text-primary-300 transition-colors leading-snug">
                  {exp.title}
                </h2>
                <div className="flex flex-wrap items-center gap-2 text-sm text-white/70">
                  <span className="font-semibold text-primary-400">{exp.company}</span>
                  {exp.location && (
                    <>
                      <span className="text-white/30">•</span>
                      <span>{exp.location}</span>
                    </>
                  )}
                </div>
              </div>
              <span className="px-3.5 py-1.5 rounded-full bg-white/[0.05] border border-white/10 text-xs font-semibold text-white/80 whitespace-nowrap self-start">
                {exp.period}
              </span>
            </div>

            <p className="text-white/80 leading-relaxed text-sm sm:text-base font-normal">
              {exp.description}
            </p>

            {exp.skills && (
              <div className="pt-2 border-t border-white/10 flex flex-wrap gap-2">
                {exp.skills.map((skill, skillIndex) => (
                  <span 
                    key={skillIndex} 
                    className="px-3 py-1 text-xs font-medium rounded-lg bg-primary-500/10 text-primary-300 border border-primary-500/20 group-hover:border-primary-500/30 transition-colors"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            )}
          </article>
        ))}
      </div>
    </div>
  );
}

export default Experience;
